import { useMutation } from "@tanstack/react-query";
import { SERVICE_API } from "@/lib/consts";

export function useLogin() {
	return useMutation({
		mutationKey: ["auth"],
		mutationFn: async (data: { email: string; password: string }) => {
			const res = await fetch(`${SERVICE_API}/api/auth/login`, {
				method: "POST",
				credentials: "include",
				body: JSON.stringify(data),
				headers: {
					"Content-Type": "application/json",
				},
			});
		},
	});
}
